export default {
  "nav.events": "Иш-чаралар",
  "nav.gallery": "Галерея",
  "nav.contact": "Байланыш",

  "hero.benefit": "3 Зал • 10 DJ • 1 Толук билет",
  "hero.getTickets": "Билет алуу",
  "hero.soldOut": "Сатылып бүттү",

  "land.saveDate": "Күндү белгилеп кой",
  "land.upcomingA": "Алдыдагы",
  "land.upcomingB": "иш-чаралар",
  "land.festival": "Фестиваль",
  "land.getTicketsArrow": "Билет алуу →",

  "home.watchEyebrow": "Афтермуви жана видеолор",
  "home.watchA": "Takeover-ди",
  "home.watchB": "көр",
  "home.stagesEyebrow": "Бир билет, үч дүйнө",
  "home.stagesA": "Тааныш",
  "home.stagesB": "3 Сахна",
  "stage.seoul.name": "Seoul Floor",
  "stage.seoul.desc": "SeoulVibes менен",
  "stage.seoul.floor": "7-кабат",
  "stage.main.name": "Mainstream Floor",
  "stage.main.desc": "Классикалык DUPLEX тажрыйбасы",
  "stage.main.floor": "6-кабат",
  "stage.saigon.name": "Saigon Floor",
  "stage.saigon.desc": "GANGSHII менен",
  "stage.saigon.floor": "5-кабат",
  "home.lineupEyebrow": "Лайнап",
  "home.whoA": "Ким ойнойт",
  "home.whoB": "— жана качан?",
  "home.insideEyebrow": "Жогорудан",
  "home.insideA": "Duplex",
  "home.insideB": "ичинде",
  "home.ctaA": "Takeover-гө",
  "home.ctaB": "даяарсыңбы?",
  "home.buyTickets": "Билет сатып алуу",

  "footer.tagline": "Прагадагы эң чоң азиялык фестиваль тажрыйбасы. Үч зал, бир билет, унутулгус түн.",
  "footer.quickLinks": "Тез шилтемелер",
  "footer.faq": "Көп берилген суроолор",
  "footer.terms": "Шарттар жана эрежелер",
  "footer.privacy": "Купуялык саясаты",
  "footer.refund": "Кайтаруу саясаты",
  "footer.followUs": "Бизди көзөмөлдө",
  "footer.rights": "© 2026 ASIA TAKEOVER. Бардык укуктар корголгон.",
  "footer.doorStaff": "Кирүү кызматкери",
  "footer.admin": "Admin",

  "cookies.title": "Cookies",
  "cookies.text": "Биз сайтты иштетүү жана буйрукту иштетүү үчүн зарыл cookies колдонобуз. Сиздин уруксатыңыз менен жарнаманын натыйжалуулугун өлчөө үчүн аналитикалык жана маркетингдик cookies (Meta Pixel) да колдонобуз. Кошумча cookies-тен баш тартып, билетти сатып алсаңыз болот.",
  "cookies.necessary": "Зарыл (дайыма күйүк)",
  "cookies.analytics": "Аналитика",
  "cookies.marketing": "Маркетинг / Meta Pixel",
  "cookies.acceptAll": "Бардыгын кабыл алуу",
  "cookies.customize": "Таңдоо",
  "cookies.save": "Сактоо",
  "cookies.reject": "Баш тартуу",

  "tickets.eyebrow": "Билеттер",
  "tickets.standard": "Standard билет",
  "tickets.group": "4 адамдык топ",
  "tickets.vip": "VIP стол билети",
  "tickets.nextRelease": "Кийинки сатуу:",
  "tickets.finalRelease": "Онлайн билеттердин акыркы сатылымы",
  "tickets.soldOut": "Сатылып бүттү",
  "tickets.buy": "Билет алуу",
  "tickets.buyGroup": "Топ билетин алуу",
  "tickets.groupPerPerson": "4 × Standard билет · ар бир адамга {price}",
  "tickets.limitedCapacity": "Саны чектелген",
  "tickets.reserve": "Стол брондоо",
  "tickets.vipRequired": "VIP стол билети керек",
  "tickets.wantTable": "Bottle service менен стол брондогуңуз келеби? VIP стол билети керек.",
  "tickets.noRefund": "Билеттер кайтарылбайт · уюштуруучу иш-чараны жокко чыгарса гана 100% кайтарылат",
  "tickets.swipe": "Көбүрөөк көрүү үчүн жылдыр",
  "tickets.priceProgression": "Ар бир сатуу бүткөндө баа көтөрүлөт",
  "tickets.loading": "Билеттер жүктөлүүдө…",
  "tickets.unavailable": "Билеттер учурда жеткиликсиз",
  "perks.std1": "Бардык 3 сахнага кирүү",
  "perks.std2": "Туруу аймагы жана бий талаасы",
  "perks.std3": "Бардык жалпы барларга жана rooftop-торго кирүү",
  "perks.no1": "VIP стол аймагына кирүү жок",
  "perks.no2": "Брондолгон стол же кепилденген орун жок",
  "perks.no3": "Bottle service жок",
  "perks.vip1": "Күтүлбөгөн белек ❤️‍🔥🎈 (баасы 200 Kč)",
  "perks.vip2": "Seoul Floor (7-кабат) жана Saigon Floor (5-кабат) VIP аймактарына кирүү.",
  "tickets.gold": "VIP Gold Table",
  "tickets.goldBadge": "Болгону 3 стол",
  "tickets.goldFee": "Үстөл акысы 3999 Kč + ар бир конок 899 Kč",
  "perks.gold1": "Сахнага жакын стол",
  "perks.gold2": "Бардык 3 сахнага кирүү",
  "perks.gold3": "Seoul Floor (7-кабат) жана Saigon Floor (5-кабат) VIP аймактарына кирүү",
  "perks.gold4": "Артыкчылыктуу кирүү, VIP даараткана жана hostess кызматы",
  "perks.gold5": "Ар бир конокко 1 күтүлбөгөн белек",
  "perks.gold6": "Bottle service өзүнчө",
  "tickets.buyGold": "Gold Table сатып алуу",
  "checkout.guestsGold": "Коноктор (4–14)",
  "checkout.guestsWord": "конок",
  "hero.upgrade": "VIPге жаңыртуу",
  "upgrade.title": "VIPге жаңыртуу",
  "upgrade.subtitle": "Standard билетиңиз барбы? 400 Kčгө VIP Table билетине айландырыңыз.",
  "upgrade.codeLabel": "Билет кодуңуз",
  "upgrade.codePlaceholder": "ATF-XXXXXX",
  "upgrade.verify": "Билетти текшерүү",
  "upgrade.found": "Билет табылды",
  "upgrade.priceLine": "Жаңыртуу баасы",
  "upgrade.sameQr": "QR кодуңуз өзгөрбөйт — төлөмдөн кийин VIP болуп сканерленет.",
  "upgrade.pay": "Жаңыртууну төлөө",
  "upgrade.processing": "Төлөм түзүлүүдө…",
  "success.upgradeNote": "Билетиңиз эми VIP — баштапкы QR кодду колдонуңуз.",
  "perks.vip3": "Bottle service менен VIP стол брондого болот",
  "perks.vip4": "Брондолгон столго hostess кызматы",
  "perks.vip5": "7-кабаттагы VIP балконго кирүү",
  "perks.vip6": "Артыкчылыктуу кирүү",
  "perks.vip7": "VIP даараткана",

  "checkout.secure": "Коопсуз төлөм",
  "checkout.fullName": "Толук аты-жөнү",
  "checkout.namePlaceholder": "Атыңыз",
  "checkout.email": "Email",
  "checkout.phone": "Телефон номери",
  "checkout.quantity": "Саны",
  "checkout.ticketOne": "билет",
  "checkout.ticketMany": "билет",
  "checkout.groupNote": "1 топ = 4 билет",
  "checkout.discountCode": "Арзандатуу коду",
  "checkout.enterCode": "Кодду киргизүү",
  "checkout.apply": "Колдонуу",
  "checkout.codeApplied": "{code} коду колдонулду: −{percent}% (баштапкы баа {price})",
  "checkout.continueToPayment": "Төлөмгө өтүү",
  "checkout.secureNote": "Teya аркылуу коопсуз карталык төлөм, ушул бетте. Билеттер төлөм ырасталгандан кийин гана берилет.",
  "checkout.termsNoteA": "Улантуу менен сиз биздин",
  "checkout.termsNoteB": "Шарттар жана эрежелер",
  "checkout.termsNoteC": "менен макулдашасыз. Билеттер кайтарылбайт жана эркин өткөрүп берилет.",
  "checkout.creating": "Буйрук түзүлүүдө…",
  "checkout.securePayment": "Коопсуз төлөм",
  "checkout.groupTickets": "1 топ (4 билет)",
  "checkout.teyaNote": "Төлөмдөрдү Teya иштетет. QR коддору бар билеттер төлөм ырасталгандан кийин дароо email-ге келет.",
  "checkout.promoApplyFirst": "Төлөөнүн алдында арзандатуу кодун активдештирүү үчүн Колдонуу баскычын басыңыз.",

  "success.confirming": "Төлөм ырасталууда…",
  "success.confirmingText": "Биз төлөмүңүздү төлөм шлюзу менен текшерип жатабыз. Бул барак автоматтык түрдө жаңыланат — жаңылоонун кереги жок.",
  "success.slowNote": "Кадимкиден бир аз узакка созулду — төлөмүңүз дагы эле ырасталууда. Даяр болгондо билеттер ушул жерде пайда болот жана email-ге да жиберебиз. Баракты ачык калтырсаңыз болот.",
  "success.confirmed": "Төлөм ырасталды",
  "success.youreIn": "Сиз ичтесиз!",
  "success.orderLine": "Буйрук {order} · {tier} × {qty} · {amount} · Билеттерди скриншот кылып, кирүүдө QR кодду көрсөтүңүз.",
  "success.loadingTickets": "Билеттер жүктөлүүдө…",
  "success.notCompleted": "Төлөм аяктаган жок",
  "success.cancelled": "Төлөм жокко чыгарылды.",
  "success.expired": "Төлөм сессиясынын мөөнөтү бүттү.",
  "success.failed": "Төлөм ийгиликсиз болду.",
  "success.noCharge": "Билеттер берилген жок жана сизден акча алынган жок.",
  "success.backToTickets": "Билеттерге кайтуу",
  "success.refunded": "Буйрук кайтарылды",
  "success.refundedText": "Бул буйрук {how} кайтарылды.",
  "success.fully": "толук",
  "success.partially": "жарым-жартылай",
  "success.notFound": "Буйрук табылган жок",
  "success.notFoundText": "Бул буйрукту таба алган жокпуз. Эгер жаңы төлөсөңүз, бир аз күтүп, кайра текшериңиз.",
  "success.backHome": "← Башкы бетке",

  "reserve.eyebrow": "VIP стол билети",
  "reserve.titleA": "Стол",
  "reserve.titleB": "брондоо",
  "reserve.intro": "Эмне керектигин айтыңыз — биз стол варианттары жана bottle service деталдары менен кайрылсабыз.",
  "reserve.received": "Сурам кабыл алынды",
  "reserve.receivedText": "Жакында VIP столуңузду түзүү үчүн сиз менен байланышабыз. 27.09-да DUPLEX-те жолукканча.",
  "reserve.back": "← Билеттерге кайтуу",
  "reserve.fullName": "Толук аты-жөнү",
  "reserve.phone": "Телефон номери",
  "reserve.email": "Email",
  "reserve.guests": "Коноктордун саны",
  "reserve.floor": "Каалаган кабат",
  "reserve.message": "Билдирүү (милдеттүү эмес)",
  "reserve.messagePlaceholder": "Окуя, бюджет, ичимдик тандоосу…",
  "reserve.send": "Сурам жиберүү",
  "reserve.sending": "Жиберилүүдө…",

  "contact.eyebrow": "Байланыш",
  "contact.title": "Байланышкыла",
  "contact.email": "Email",
  "contact.instagram": "Instagram",
  "contact.venue": "Жайгашкан жер",
  "contact.note": "VIP столдор, өнөктөштүк жана басма сөз боюнча email жазыңыз — 48 сааттын ичинде жооп беребиз.",

  "gallery.eyebrow": "Галерея",
  "gallery.titleA": "Үйдүн",
  "gallery.titleB": "картасы",
  "gallery.rooms": "KPOP зал • Mainstream зал • Saigon зал",
};
